import { IonActionSheet } from "@ionic/react";
import { type ReactNode, useState } from "react";

import getPlatformUrl from "@/utils/getPlatformUrl.js";
import { hooks, type AirplaneInit } from "@/store.js";
import { useMemoizedFn, useRequest } from "ahooks";
import useConfirm from "@/hooks/useConfirm/index.jsx";
import showErrMessage from "@/utils/showErrMessage.js";
import { toast } from "sonner";
import { planDetailEvent } from "../../utils/event.js";

const useMenu = ({
	id,
	showEdit,
	planId,
	eventId,
}: {
	id?: string;
	planId: string;
	eventId?: string;
	showEdit: ({
		defaultValue,
		id,
	}: {
		defaultValue?: AirplaneInit;
		id?: string;
		planId: string;
	}) => void;
}) => {
	const [placeholder, setPlaceholder] = useState<ReactNode>();
	const client = hooks.useClient();
	const { loading: deleting, runAsync: runDelete } = useRequest(
		async () => {
			if (!eventId) throw new Error("未传入id");

			return await client.events.delete(eventId);
		},
		{
			manual: true,
			onError: showErrMessage,
			onSuccess() {
				setTimeout(() => {
					planDetailEvent.emit("requestRefresh");
				}, 1000);

				toast.success("删除成功");
			},
		},
	);
	const { showModal } = useConfirm({
		isSubmitting: deleting,
		onSubmit: runDelete,
		title: "确定删除该活动吗?",
	});

	const show = useMemoizedFn((defaultValue: AirplaneInit) => {
		// if (!id) return; // NOTICE: 没有就是新建
		const { pnr, itinerary, platform, orderId } = defaultValue;
		const platformUrl = getPlatformUrl(platform, orderId);
		setPlaceholder(
			<IonActionSheet
				header={pnr}
				isOpen
				onDidDismiss={(e) => {
					// setActionOpen(false);
					setPlaceholder(null);
				}}
				buttons={[
					{
						text: "编辑",
						handler() {
							showEdit({
								defaultValue,
								id,
								planId,
							});
						},
					},
					{
						text: "行程单",
						data: {
							action: "itinerary",
						},
						handler: () => {
							window.open(
								itinerary?.startsWith("http")
									? itinerary
									: `https://trip-qiniu.pmlife.top/${itinerary}`,
								"_blank",
							);
						},
						disabled: !itinerary,
					},

					{
						text: platform || "平台",
						data: {
							action: "platform",
						},

						handler: () => {
							if (platformUrl) {
								window.open(platformUrl, "_blank");
							}
						},
						disabled: !platform || !platformUrl,
					},

					{
						text: "删除",
						data: {
							action: "delete",
						},
						handler: showModal,
					},
					{
						text: "Cancel",
						role: "cancel",
						data: {
							action: "cancel",
						},
					},
				]}
			/>,
		);
	});

	return {
		show,
		placeholder,
	};
};

export default useMenu;
